import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

function hasToken() {
  return Boolean(localStorage.getItem('auth_token'));
}

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!hasToken()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  return children;
}
